/* eslint-disable arrow-body-style */

export default {
  computed: {

    licensesAll() {
      if (!this.type || !this.type.Fields) return null;
      const licensesOptions = this.type.Fields.find((el) => {
        return el.Name === 'Licenses';
      });
      return typeof licensesOptions.WidgetOptions !== 'undefined'
        ? licensesOptions.WidgetOptions : null;
    },

  },
};



// WEBPACK FOOTER //
// ./src/mixins/Object.js